'use client';

import { BannerSelling } from '@/slw/widgets/common/banner-selling.ui';
import { Breadcrumb } from '@/slw/widgets/common/breadcrumb.ui';
import { MainSearchResults } from '@/slw/widgets/search-results/main-search-results.ui';

export function SearchResultsPage() {
  const breadcrumbs = [{ name: 'Search results' }];

  return (
    <>
      <section className='section-main-content'>
        <div className='container'>
          <Breadcrumb data={breadcrumbs} />

          <MainSearchResults />
        </div>
      </section>

      <div className='mb-20 mt-20'>
        <BannerSelling />
      </div>
    </>
  );
}
